
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/factor/v2/[slug]/[service_id]",
      function () {
        return require("private-next-pages/factor/v2/[slug]/[service_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/factor/v2/[slug]/[service_id]"])
      });
    }
  